import { b } from './chunk-IMSWER4T.js';

var r=class extends b{URL="product-status";async getAllStatuses(){return (await(await this._client.get("/product-status")).data).data}};

export { r as a };
//# sourceMappingURL=chunk-W2R4O7OB.js.map
//# sourceMappingURL=chunk-W2R4O7OB.js.map